/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React ,{useState,useEffect} from "react";
import { Redirect, Switch, Route } from "react-router-dom";
// import { shallowEqual, useSelector } from "react-redux";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import Login from "./modules/Auth/pages/Login";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import { GetCookies } from "../_metronic/_helpers/Cookies";
import axios from "axios"
import { BASE_URL ,NODE_API_URL,REACT_BASE_URL} from "./../env_config"
import languages from '../_metronic/_helpers/languages.json'

export function Routes(props) {
  const [localstored,setLocalStored] = useState(false)
  const [isAuthorized,setAuth] = useState(true)
  const [isprofilecomplete,setProfileComplete] = useState(false)
  const [userinfo,setUserInfo] = useState({})
  const [language,setLanguage] = React.useState("en")
  const [conversionrate,setConversionRate] = useState(1)
  const [symbol,setSymbol] = useState("$")
  const [symbolname,setSymbolName] = useState("USD")
  const [updatecurrency,setUpdateCurrency] = useState(null)
  // const { isAuthorized } = useSelector(
  //   ({ auth }) => ({
  //     isAuthorized: auth.user != null,
  //   }),
  //   shallowEqual
  // );

  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    // console.log(result,"addDays")
    return result.toISOString();
  }
  const getActive = (date) => {
    let newdate = new Date().getTime()
    let userdate = new Date(date).getTime()
    let status = true
    if(userdate <= newdate){
        status = false
    }
    return status
}
  useEffect(() => {
  
    // let resData = {"CustomerId":2399,"CompanyName":"Test2","EMail":"ios23user@gmail.com","ContactNo":"+91 7623901390","CompanyAddress":"test 1 test 1 surat 395007","SalesPerson":"test account","Currency":"INR","CustomerType": 3,"Country":"India"}
    // GetCookies("BaseUrl").then(response => {
    //   if(response){
    //     let thisDomain = REACT_BASE_URL
    //     // let resDomain = JSON.stringify(response)
    //     // console.log("thisDomain",thisDomain)
    //     // console.log("resDomain",response)
    //     if (thisDomain !== response){
    //         window.location.replace(`${response}dashboard`)
    //     }
    //   }
    // })
    // let resData = {"CustomerId":52263,"CompanyName":"Test3","EMail":"dikoges397@xtrempro.com","ContactNo":"+244 1212121","CompanyAddress":"surattest","SalesPerson":"test account","Currency":"AUD","CustomerType": 7,"Country":"India"}
    // let currencyData = [{"CurrencyCd":"INR","Currency":"India Ruppee","ConversionRate":81.72}]
    // localStorage.setItem("C_id",-1)
    // localStorage.setItem("userData", JSON.stringify(resData))
    // localStorage.setItem("userCurrency", JSON.stringify(currencyData))
    // {"id":"50022","cname":"Test2","fname":"anita","lname":"hugley","mail":"ios23user@gmail.com","invoiceemail":"dikoges397@xtrempro.com","mail1":"","mobile":"+91 9316635770","password":"0e7517141fb53f21ee439b355b5a1d0a","passport_id":"123123123","passport_file":"152.pdf","work_profile":"ceo","reset_password_token":"","roomno":null,"floor":null,"b_no":null,"street":null,"area":"","address":"626 griffin street phoenix, az 85017","secaddress":"626 griffin street phoenix, az 85017","city":"surat","state":"","country":"India","com_zip":"395007","website":"","birthdate":null,"skype":null,"com_reg_no":"100000000","com_reg_doc":"151.pdf","nature_buss":"jewelry manufacture","buss_esta_date":"2021-02-02","director_name":"mansi patel","directory_contact":"+1 342342342","shipping_phone":"+1435435435345","shipping_email":"anitazhugley@armyspy.com","company_tax":"","port_discharge":"","port_of_discharge":"India","importref":"","contact1":"","contact2":"+1435435435345","fax":"+1 345345","repnet_id":"","discount":"0","lab_discount":"0","send_weekly_mail":"0","mail_status":"0","weekly_mail_status":"0","created_date":"2021-12-07 15:45:36","created_by":"13","type":"","company_name":"","lab_company_name":"","status":"0","shipping_charge":"0","shipping_address":"<p>anita testing<br>626 griffin street phoenix, az 85017, 626 griffin street phoenix, az 85017<br>surat, 395007<br>India<\/p>","comment":"\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t","cus_tags":"","api_pass":"","is_deleted":"0","is_approved":"1","verify_email_token":"","is_verify":"1","v_customer":"3","api":"1","api_key":"","ap_created_date":"0000-00-00 00:00:00","api_test_mode":"OFF","api_test_key":"","aptest_created_date":"2021-12-22 16:26:13","api_live_mode":"0","supplier_api_request":"0","feed_type":"API","on_off":"1","app_auth_token":"","device_token":"","notificatioin_read_status":"1","notificatioin_status":"0","notification_all":"1","notifiaction_confirm_diamond":"1","notifiaction_invoice":"1","notifiaction_shipment":"1","notifiaction_email_confirm_diamond":"1","notifiaction_email_invoice":"1","notifiaction_email_shipment":"1","source":"","username":"","kyc_status":"KYC_APPR","billing_address":"","api_id":null,"kyc_apprv_by":null,"kyc_apprv_date":null,"sales_level_1":"13","sales_level_2":null,"sales_level_3":null,"sales_level_4":null,"show_me_check":"1","dashboard_check_box":"1","service_charge_discount":"0","in_out_bound":null,"default_currency":"INR"}
    GetCookies("user_data_test").then(response => {
      // console.log("Routes call")
      // console.log(window.location.origin)
      // setAuth(true)
        if(response){
            let cookiesdata = JSON.parse(response)
            let resData = {"CustomerId":cookiesdata.id,"fname":cookiesdata.fname,"lname":cookiesdata.lname,"CompanyName":cookiesdata.cname,"EMail":cookiesdata.mail,"ContactNo":cookiesdata.mobile,"CompanyAddress":cookiesdata.address,"SalesPerson":"test account","Currency":cookiesdata.default_currency,"CustomerType":cookiesdata.v_customer,"Country":cookiesdata.country,"shipping_email":cookiesdata.shipping_email}
            let currencyData = [{"CurrencyCd":"AUD","Currency":"Australian Dollar","ConversionRate":1.466031}]
              localStorage.setItem("C_id",-1)
              localStorage.setItem("userData", JSON.stringify(resData))
              localStorage.setItem("userCurrency", JSON.stringify(currencyData))
              setLocalStored(true)
              // setAuth(true)
              axios({
                method: "POST",
                url: NODE_API_URL + "/TESTMODE/ProfileValidator",
                headers: { "Content-Type": "application/json" },
                data: {
                  "user_id":resData.CustomerId
                },
              }).then((res) => {
                if (res && res.data && res.data.success) {
                    // console.log(res.data.data.isprofileapproved,"success")
                    if(!getActive(addDays(res.data.data.userdata.aptest_created_date,6))){
                      setAuth(false)
                      var cookies = document.cookie.split(";");
                      for (var i = 0; i < cookies.length; i++) {
                        var equals = cookies[i].indexOf("=");
                        var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                      }
                       window.location.replace(`/`);

                    }
                    else if(!res.data.data.userdata.api_test_key){
                      setAuth(false)
                      var cookies = document.cookie.split(";");
                      for (var i = 0; i < cookies.length; i++) {
                        var equals = cookies[i].indexOf("=");
                        var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                      }
                   window.location.replace(`/`);

                    }
                    else if(res.data.data.userdata.api !== 1){
                      setAuth(false)
                      var cookies = document.cookie.split(";");
                      for (var i = 0; i < cookies.length; i++) {
                        var equals = cookies[i].indexOf("=");
                        var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                      }
                   window.location.replace(`/`);

                    }
                    else{
                      setProfileComplete(res.data.data.isvalidprofile)
                      setUserInfo(res.data.data.userdata)
                    }
                }
                else{
                   setAuth(false)
                   var cookies = document.cookie.split(";");
                   for (var i = 0; i < cookies.length; i++) {
                     var equals = cookies[i].indexOf("=");
                     var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                     document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                   }
                   window.location.replace(`/`);
                }
              });
          GetCookies("sales_person").then(salesperson => {
            if (salesperson === "1") {
              setTimeout(() => {
                localStorage.clear()
                var cookies = document.cookie.split(";");
                for (var i = 0; i < cookies.length; i++) {
                  var equals = cookies[i].indexOf("=");
                  var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
                  document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                }
                window.location.replace(`/login`);
              }, 300000)
            }
          })
        }
        else{
          //  window.location.replace(`/login`);
           setAuth(false)
           var cookies = document.cookie.split(";");
           for (var i = 0; i < cookies.length; i++) {
             var equals = cookies[i].indexOf("=");
             var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
             document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
           }
        }
    })
    GetCookies("language").then(response => {  
      if(response){
          setLanguage(response)
      }
  })
  GetCookies("currency").then(responsecurrency => {
    GetCookies("conversionrates").then(responseconversion => {
      if(responsecurrency && responseconversion){
        const findconv = JSON.parse(responseconversion)[0][responsecurrency]
        setConversionRate(Math.round(responsecurrency === "cur_inr"?((findconv + 0.25) * 100):(findconv * 100))/100)
        setSymbolName(responsecurrency.split('_')[1].toUpperCase())
        if(responsecurrency === "cur_inr"){
          setSymbol("₹")
        }
        if(responsecurrency === "cur_usd"){
          setSymbol("$")
        }
        if(responsecurrency === "cur_aud"){
          setSymbol("$")
        }
        if(responsecurrency === "cur_cad"){
          setSymbol("$")
        }
        if(responsecurrency === "cur_hkd"){
          setSymbol("$")
        }
        if(responsecurrency === "cur_cny"){
          setSymbol("¥")
        }
        if(responsecurrency === "cur_eur"){
          setSymbol("€")
        }
        if(responsecurrency === "cur_gbp"){
          setSymbol("£")
        }
        if(responsecurrency === "cur_nzd"){
          setSymbol("$")
        }
        if(responsecurrency === "cur_jpy"){
          setSymbol("¥")
        }
        if(responsecurrency === "cur_chf"){
          setSymbol("₣")
        }
      }
    })
})
},[updatecurrency])
  return (
    <Switch>
      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to="/" />
      )}

      <Route path="/error" component={ErrorsPage} />
      <Route path="/logout" component={Logout} />

      {!isAuthorized ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to="/auth/login" />
      ) : (
        localstored? <Layout language={languages[language]} userinfo={userinfo} setUpdateCurrency={setUpdateCurrency}>
          <BasePage localstored={localstored} language={languages[language]} conversionrate={conversionrate} symbol={symbol} isprofilecomplete={isprofilecomplete} userinfo={userinfo} dataFetchedRef={props.dataFetchedRef} symbolname={symbolname} logStoredRef={props.logStoredRef}/>
        </Layout> :""
      )}
    </Switch>
  );
}
